export const CONSENT_COOKIE = 'CookieConsent'
const OUT_OF_REGION = '-1'

function readConsentCookie() {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + CONSENT_COOKIE + '=([^;]*)')
  )
  if (!match) return null
  try {
    return decodeURIComponent(match[1])
  } catch (error) {
    return match[1]
  }
}

function consentGrantsMarketing(value) {
  if (value === null || value === undefined || value === '') return false
  if (typeof value === 'object') return Boolean(value.marketing)
  const raw = String(value)
  return raw === OUT_OF_REGION || /marketing:true/.test(raw)
}

export function hasMarketingConsent(consentCookie) {
  if (typeof window !== 'undefined' && window.Cookiebot?.consent) {
    return Boolean(window.Cookiebot.consent.marketing)
  }
  if (consentCookie !== undefined) return consentGrantsMarketing(consentCookie)
  return consentGrantsMarketing(readConsentCookie())
}
